import React from "react";
import PageWrapper from "components/PageWrapper";
import FavoritesTable from "./molecules/FavoritesTable";

export function Favorites() {
    return (
        <PageWrapper>
            <FavoritesTable/>
        </PageWrapper>
    );
}
